import { Component } from '@angular/core';
import { AppStoreLinksComponent } from '../app-store-links/app-store-links.component';

@Component({
  selector: 'app-mobile-app-card',
  standalone: true,
  imports: [AppStoreLinksComponent],
  templateUrl: './mobile-app-card.component.html',
  styleUrl: './mobile-app-card.component.scss',
})
export class MobileAppCardComponent {}
